export default "__VITE_ASSET__BrG7nvDY__"